import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["partyAType", "partyAId", "partyBType", "partyBId"]

  connect() {
    console.log("Contract edit controller connected")
  }

  updatePartyOptions(event) {
    const changedSelect = event.target
    const isPartyA = changedSelect === this.partyATypeTarget
    const typeSelect = isPartyA ? this.partyATypeTarget : this.partyBTypeTarget
    const idSelect = isPartyA ? this.partyAIdTarget : this.partyBIdTarget
    const selectedType = typeSelect.value

    // Clear current options
    idSelect.innerHTML = '<option value="">Select Party ' + (isPartyA ? 'A' : 'B') + '</option>'

    if (selectedType === '') {
      return
    }

    // Fetch options based on selected type
    fetch(`/admin/contracts/party_options?type=${selectedType}`)
      .then(response => response.json())
      .then(data => {
        data.forEach(item => {
          const option = document.createElement('option')
          option.value = item.id
          option.textContent = item.display_name
          idSelect.appendChild(option)
        })
      })
      .catch(error => {
        console.error('Error fetching party options:', error)
      })
  }
}